import { useModal } from "@/hooks/modals/useModal";
import { useSourcingBy } from "./useSourcingBy";

export function useFormEditable() {
  const { props } = useModal("SOURCING_APPLICATION_20251202");

  const { isReadOnly, recordId, viewStatus } = props;
  const isSourcingBy = useSourcingBy(recordId);

  const isInReviewMode = props.mode === "inReview";
  const isStarted = props.mode === "started";

  /**
   * 满足下面条件时，主表单禁止编辑
   */
  const mainFormDisabledRules = [isStarted && isReadOnly, isInReviewMode];
  console.log("🚀 ~ useFormEditable ~ mainFormDisabledRules:", {
    mainFormDisabledRules,
  });

  /** 满足以下条件，采购维护寻源禁止编辑 */
  const sourcingByFormDisabledRules = [
    isStarted,
    isInReviewMode && isSourcingBy && !viewStatus,
  ];
  console.log(
    "🚀 ~ useFormEditable ~ sourcingByFormDisabledRules:",
    sourcingByFormDisabledRules,
  );

  return {
    isMainFormDisabled: mainFormDisabledRules.some((rule) => !!rule),
    isSourcingByFormDisabled: sourcingByFormDisabledRules.some(
      (rule) => !!rule,
    ),
  };
}
